<template>
  <article class="color">
    <div class="color__swatch" :style="{backgroundColor: data.color}"></div>
    <div class="color__names">
      <div class="color__name title" @click="copyToClipboard(usedInMixin(data.name))">
        <span>{{usedInMixin(data.name)}}</span>
      </div>

      <div v-if="isRgbOrHex(data.color) === 'hsla'" class="color__name">
        <div class="color__name__row">
          <span>{{ hslaToRgba(data.color) }}</span>
          <div v-if="showCopyMessage && copyColorSpace === 'hsla'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('hsla', hslaToRgba(data.color))" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
      </div>

      <div v-if="isRgbOrHex(data.color) === 'rgba'" class="color__name">
        <div class="color__name__row">
          <span>{{ convertRgba(data.color) }}</span>
          <div v-if="showCopyMessage && copyColorSpace === 'rgba'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('rgba', convertRgba(data.color))" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
      </div>

      <div v-if="isRgbOrHex(data.color) === 'rgb'" class="color__name">
        <div class="color__name__row">
          {{rgbtoHex(data.color)}}
          <div v-if="showCopyMessage && copyColorSpace === 'rgb'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('rgb', rgbtoHex(data.color))" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
        <div class="color__name__row">
          {{data.color}}
          <div v-if="showCopyMessage && copyColorSpace === 'hex'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('hex', data.color)" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
        <div class="color__name__row">
          {{hexToCmyk(rgbtoHex(data.color))}}
          <div v-if="showCopyMessage && copyColorSpace === 'cmyk'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('cmyk', hexToCmyk(rgbtoHex(data.color)))" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
      </div>

      <div v-if="isRgbOrHex(data.color) === 'hex'" class="color__name">
        <div class="color__name__row">
          {{data.color}}
          <div v-if="showCopyMessage && copyColorSpace === 'hex'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('hex', data.color)" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
        <div class="color__name__row">
          {{hexToRgb(data.color)}}
          <div v-if="showCopyMessage && copyColorSpace === 'rgb'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('rgb', hexToRgb(data.color))" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
        <div class="color__name__row">
          {{hexToCmyk(data.color)}}
          <div v-if="showCopyMessage && copyColorSpace === 'cmyk'" class="copied">
            <fds-icon name="check" size="24"></fds-icon> Done
          </div>
          <fds-button v-else variant="minor" icon="copy" @click="copyToClipboard('cmyk', hexToCmyk(data.color))" class="copy">
            <button>Copy</button>
          </fds-button>
        </div>
      </div>

    </div>

  </article>
</template>

<script>

export default {
  name: 'ColorSwatch',
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showCopyMessage: false,
      copyColorSpace: ''
    }
  },
  methods: {
    isRgbOrHex (color) {
      const rgbaPattern = /^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(?:0?\.\d{1,4}|1(?:\.0{1,4})?)\s*\)$/i
      const rgbPattern = /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/i
      const hexPattern = /^#?([a-f\d]{3}|[a-f\d]{6})$/i
      const hslaPattern = /^hsla\(\s*\d{1,3}\s*,\s*\d{1,3}%\s*,\s*\d{1,3}%\s*,\s*(?:0?\.\d{1,4}|1(?:\.0{1,4})?)\s*\)$/i

      if (hexPattern.test(color)) {
        return 'hex'
      } else if (rgbaPattern.test(color)) {
        return 'rgba'
      } else if (rgbPattern.test(color)) {
        return 'rgb'
      } else if (hslaPattern.test(color)) {
        return 'hsla'
      } else {
        return 'invalid'
      }
    },
    hslaToRgba (hsla) {
      // Regex to capture hsla( hue, saturation%, lightness%, alpha )
      const hslaPattern = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*(0?\.\d+|1)\s*\)$/i

      // Test if the input is in hsla format
      const match = hsla.match(hslaPattern)
      if (!match) {
        return hsla // If not a valid hsla string, return as-is
      }

      // Extract H, S, L, and A values
      const h = parseInt(match[1], 10) // Hue
      const s = parseInt(match[2], 10) / 100 // Saturation
      const l = parseInt(match[3], 10) / 100 // Lightness
      const a = parseFloat(match[4]) // Alpha

      // Convert HSL to RGB
      const rgb = this.hslToRgb(h, s, l)

      // Return the equivalent rgba() string
      return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${a.toFixed(4)})`
    },
    hslToRgb (h, s, l) {
      // Normalize the hue to a value between 0 and 1
      const hue = h / 360

      // If saturation is 0, it's a shade of gray
      if (s === 0) {
        const gray = Math.round(l * 255)
        return { r: gray, g: gray, b: gray }
      }

      // Calculate temporary values for RGB conversion
      const temp2 = l < 0.5 ? l * (1 + s) : l + s - l * s
      const temp1 = 2 * l - temp2

      const r = Math.round(255 * this.hueToRgb(temp1, temp2, hue + 1 / 3))
      const g = Math.round(255 * this.hueToRgb(temp1, temp2, hue))
      const b = Math.round(255 * this.hueToRgb(temp1, temp2, hue - 1 / 3))

      return { r, g, b }
    },
    hueToRgb (p, q, t) {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    },
    convertRgba (color) {
      // Extract the RGBA values using a regular expression
      const rgbaValues = color.match(/(\d+(\.\d+)?|\.\d+)/g)

      if (!rgbaValues || rgbaValues.length < 4) return color // If not a valid RGBA string, return as-is

      let [r, g, b, a] = rgbaValues // Destructure RGBA values

      // Ensure the alpha value has a leading zero if it's less than 1
      a = a.startsWith('.') ? `0${a}` : a

      // Return the modified RGBA string without commas
      return `rgba(${r} ${g} ${b} / ${a})`
    },
    usedInMixin (name) {
      if (name.split('-')[0] === 'color') {
        const category = name.split('-')
        return `${category[2]}`
      }
    },
    rgbtoHex (rgba) {
      // Check if the input is a valid rgba or rgb format using regex
      const isValidRgb = /^rgba?\(\d+,\s*\d+,\s*\d+(,\s*(0|1|0?\.\d+))?\)$/i.test(rgba)

      if (!isValidRgb) {
        return null
      }

      const rgbaValues = rgba.match(/\d+(\.\d+)?/g) // Extracts numbers from the string

      const toHex = (n) => {
        const hex = parseInt(n).toString(16)
        return hex.length === 1 ? '0' + hex : hex
      }

      // Convert RGB to hex
      const r = toHex(rgbaValues[0])
      const g = toHex(rgbaValues[1])
      const b = toHex(rgbaValues[2])

      // Convert alpha to hex (if alpha is provided)
      const alpha = rgbaValues[3] ? Math.round(parseFloat(rgbaValues[3]) * 255).toString(16) : 'ff'

      return `#${r}${g}${b}${alpha}`
    },
    hexToRgb (hex) {
      if (hex === '#fff') {
        hex = '#ffffff'
      }
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

      const rgb = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null
      if (rgb) {
        return `rgb(${rgb.r} ${rgb.g} ${rgb.b})`
      }
    },
    hexToCmyk (hex) {
      let hex2 = hex
      // Check if hex is valid: either 3 or 6 digits and optionally starts with '#'
      if (hex2 && hex2.length > 7) {
        hex2 = hex2.slice(0, 7)
      }
      const validHex = /^#?([a-f\d]{3}|[a-f\d]{6})$/i.test(hex2)

      if (!validHex) {
        return 'Invalid hex code'
      }

      // Remove the hash at the start if it's there
      hex = hex.replace(/^#/, '')

      // If shorthand hex (e.g., #abc), convert to full form (e.g., #aabbcc)
      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('')
      }

      // Convert hex to RGB
      const r = parseInt(hex.slice(0, 2), 16) / 255
      const g = parseInt(hex.slice(2, 4), 16) / 255
      const b = parseInt(hex.slice(4, 6), 16) / 255

      // Calculate CMYK values
      const k = 1 - Math.max(r, g, b)
      const c = (1 - r - k) / (1 - k) || 0
      const m = (1 - g - k) / (1 - k) || 0
      const y = (1 - b - k) / (1 - k) || 0

      // Format the output as percentages
      const cmykString = `C ${Math.round(c * 100)}% M ${Math.round(m * 100)}% Y ${Math.round(y * 100)}% K ${Math.round(k * 100)}%`

      return cmykString
    },
    copyToClipboard (colorspace, str) {
      var el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style = { position: 'absolute', left: '-9999px' }
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.showCopyMessage = true
      this.copyColorSpace = colorspace
      setTimeout(
        function () {
          this.showCopyMessage = false
          this.copyColorSpace = ''
        }.bind(this),
        800
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.color {
  position: relative;
  flex-direction: row;
  display: flex;
  border-radius: set-radius('m');
  overflow: hidden;
  &__swatch {
    width: 100%;
    max-width: 88px;
  }
  &__names {
    background-color: set-color('white_t', 'solid');
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    justify-content: center;
    padding: set-gutter('m');
    width: 100%;
    .color__name {
      justify-content: space-between;
      position: relative;
      display: flex;
      white-space: nowrap;
      flex-direction: column;
      gap: set-gutter('xs');
      &__row {
        display: flex;
        justify-content: space-between;
      }
      &.title {
        font-weight: bold;
        margin-bottom: set-gutter('s');
      }
      .copy {
        color: set-color('blue', 700);
        text-decoration: underline;
        font-weight: normal;
      }
      &:active {
        .copy {
          color: set-color('blue', 700)
        }
      }
      &:hover {
        .copy {
          display: inline-block;
        }
      }
    }
  }

  .copy-message {
    position: absolute;
    top: set-gutter('s');
    right: -60px;
    transform: translateX(-50%);
    white-space: nowrap;
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: opacity .2s ease-in-out;
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
  }
}

.copied {
  display: inline-flex;
  align-items: center;
  padding: 2px;
  fds-icon {
    color: set-color('green', 600) !important;
    margin-right: set-gutter('s');
  }
}

</style>
